import type { RawParams } from "@uirouter/core";

import type { ICustomDimensionData } from "@similarweb/sw-track";

import { swSettings } from "app/common/services/swSettings";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";
import { build } from "app/services/track/CustomUrlBuilderService";
import type { PageId } from "app/@types/userdata";

export async function getPageViewTrackingParams(
    toState: IRouterState,
    toParams: RawParams,
): Promise<ICustomDimensionData> {
    const pageTrackingObject: PageId = {
        ...toState.data.getTrackId(toState, toParams),
    };

    return await build(toState, pageTrackingObject, toParams, swSettings.current);
}
